import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';

const ChangeOrderTasksNotice = ({ changeOrderDetails, jobId, projectDetails }) => {
  if (!changeOrderDetails || changeOrderDetails.length === 0) {
    return null;
  }

  // Filter change order details for this job
  const jobChangeOrders = changeOrderDetails.filter(
    (detail) => detail.ProjectID === jobId
  );

  // Group incomplete tasks by engineer type
  const incompleteTasks = {
    mechanical: [],
    electrical: [],
    controls: [],
    csm: []
  };

  jobChangeOrders.forEach((detail) => {
    if (detail.ActionRequiredMechanical && !detail.MechanicalCompleted) {
      incompleteTasks.mechanical.push(detail);
    }
    if (detail.ActionRequiredElectrical && !detail.ElectricalCompleted) {
      incompleteTasks.electrical.push(detail);
    }
    if (detail.ActionRequiredControls && !detail.ControlsCompleted) {
      incompleteTasks.controls.push(detail);
    }
    if (detail.ActionRequiredCSM && !detail.CSMCompleted) {
      incompleteTasks.csm.push(detail);
    }
  });

  // Calculate total incomplete tasks
  const totalIncompleteTasks = 
    incompleteTasks.mechanical.length +
    incompleteTasks.electrical.length +
    incompleteTasks.controls.length +
    incompleteTasks.csm.length;

  // If no incomplete tasks, don't render
  if (totalIncompleteTasks === 0) {
    return null;
  }

  // Get engineer names from project details
  const mechanicalEngineer = projectDetails?.MechanicalEngineer || 'Not Assigned';
  const electricalEngineer = projectDetails?.ElectricalEngineer || 'Not Assigned';
  const controlsEngineer = projectDetails?.ControlsEngineer || 'Not Assigned';

  return (
    <Alert variant="warning" className="mb-3">
      <div className="d-flex align-items-start">
        <i className="bi bi-person-lines-fill me-2 mt-1" style={{ fontSize: '1.5rem', color: 'orange' }}></i>
        <div className="flex-grow-1">
          <h6 className="alert-heading mb-2">
            Incomplete Change Order Tasks ({totalIncompleteTasks})
          </h6>
          <p className="mb-2">
            This job has {totalIncompleteTasks} incomplete change order task{totalIncompleteTasks !== 1 ? 's' : ''} that require attention:
          </p>
          
          <ul className="mb-0">
            {incompleteTasks.mechanical.length > 0 && (
              <li>
                <strong>Mechanical:</strong> {incompleteTasks.mechanical.length} task{incompleteTasks.mechanical.length !== 1 ? 's' : ''} 
                {' '}- Assigned to: <strong>{mechanicalEngineer}</strong>
              </li>
            )}
            
            {incompleteTasks.electrical.length > 0 && (
              <li>
                <strong>Electrical:</strong> {incompleteTasks.electrical.length} task{incompleteTasks.electrical.length !== 1 ? 's' : ''} 
                {' '}- Assigned to: <strong>{electricalEngineer}</strong>
              </li>
            )}
            
            {incompleteTasks.controls.length > 0 && (
              <li>
                <strong>Controls:</strong> {incompleteTasks.controls.length} task{incompleteTasks.controls.length !== 1 ? 's' : ''} 
                {' '}- Assigned to: <strong>{controlsEngineer}</strong>
              </li>
            )}
            
            {incompleteTasks.csm.length > 0 && (
              <li>
                <strong>CSM:</strong> {incompleteTasks.csm.length} task{incompleteTasks.csm.length !== 1 ? 's' : ''} 
                {' '}- Assigned to: <strong>David Neesen</strong>
              </li>
            )}
          </ul>
        </div>
      </div>
    </Alert>
  );
};

ChangeOrderTasksNotice.propTypes = {
  changeOrderDetails: PropTypes.array.isRequired,
  jobId: PropTypes.number.isRequired,
  projectDetails: PropTypes.object
};

export default ChangeOrderTasksNotice;
